import styled from 'styled-components'

export const FormFieldWrapper = styled.div`
  position: relative;

  input:before {
    content: '\f00c';
  }
`

interface Props {
  showIcon?: boolean
}

export const FormControlValidIcon = styled.i<Props>`
  display: ${({ showIcon }) => (showIcon ? 'block' : 'none')}!important;
  color: ${(props) => props.theme.formControlValidIcon.colour};
  font-size: 16px;
  border: 4px solid
    ${(props) => props.theme.formControlValidIcon.backgroundColour};
  background-color: ${(props) =>
    props.theme.formControlValidIcon.backgroundColour};
  border-radius: 50%;
`

export const LabelFieldWrapper = styled.div`
  display: flex;
  text-align: left;
  gap: 4px;
  flex-direction: column;
  margin-bottom: ${({ theme }) => theme.formControlBottomMargin};

  @media (min-width: 768px) {
    gap: 6px;
  }
`
export const IconWrapper = styled.div`
  width: 50px;
  height: 50px;
  right: 0;
  position: absolute;
  display: flex;
  justify-content: center;
  align-items: center;

  @media (min-width: 768px) {
    height: 60px;
  }
`
